'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { useAuthStore } from '@/slw/shared/stores/auth.store';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/slw/shared/ui/dropdown-menu';
import { logout } from '@/slw/shared/lib/utils';

export function UserDropdownMenu({ isLoggedIn }: { isLoggedIn: boolean }) {
  const router = useRouter();
  const { user } = useAuthStore();

  const handleSignOut = async () => {
    await logout(); // logout() will handle redirect automatically
  };

  if (!isLoggedIn) {
    return (
      <motion.button className='outline-none!' type='button' whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
        <Image src='/images/common/avatar.png' alt='' width={32} height={32} priority />
      </motion.button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <motion.button type='button' className='outline-none!' whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
          <Image
            src={user?.avatar || '/images/common/avatar.png'}
            alt='User Avatar'
            width={32}
            height={32}
            priority
            className='rounded-full object-cover'
          />
        </motion.button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' sideOffset={12} className='min-w-[260px]  pt-2 pb-2 px-8 rounded-2xl border-0'>
        <DropdownMenuItem
          onClick={() => {
            router.push('/my-listings');
          }}
          className='text-sm py-2 cursor-pointer  px-2 leading-[150%]  font-medium'
        >
          My Listings
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            router.push('/alerts');
          }}
          className='text-sm py-2 cursor-pointer  px-2 leading-[150%] font-medium'
        >
          My Alerts
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            router.push('/inventory-analytics');
          }}
          className='text-sm py-2 cursor-pointer  px-2 leading-[150%] font-medium'
        >
          Inventory Analytics
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            router.push('/profile');
          }}
          className='text-sm  py-2 cursor-pointer  px-2 leading-[150%] font-medium'
        >
          Profile Settings
        </DropdownMenuItem>
        <DropdownMenuSeparator className='my-2 mx-0' />
        <DropdownMenuItem
          onClick={() => {
            handleSignOut();
          }}
          className='text-sm leading-[150%] cursor-pointer text-center py-2
        font-medium text-destructive justify-center'
        >
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
